import { gql } from '@apollo/client';

export const ARCHIVE_PROJECT = gql`
  mutation ARCHIVE_PROJECT($projectId: String!) {
    archiveProject(projectId: $projectId) {
      __typename
      id
      isArchived
    }
  }
`;